import { subHours, isBefore, endOfDay, endOfWeek, isAfter } from 'date-fns';
import { IEvent } from '../../domain/event/interface';

export const isPastDate = (selectedDate: Date) => {
    const targetDate = subHours(new Date(), 24);
    return isBefore(new Date(selectedDate), targetDate);
};

export const isStarted = (event: IEvent) => {
    return isAfter(new Date(), new Date(event.event_datetime_start));
};

export const toUsefulEventParams = (state: any) => ({
    ...(state.program ?? {}),
    ...(state.programId && { programId: state.programId }),
    ...(state.companyId && { companyId: state.companyId }),
    ...(state.search && { search: state.search }),
    ...(state.calendarDates && { start: new Date(state.calendarDates.start), end: new Date(state.calendarDates.end) }),
    ...(state.load_zone && { load_zone: state.load_zone }),
    ...(state.market && { market: state.market }),
    ...(state.accountManager && { account_manager: state.accountManager }),
});

export const prepareCalendarDates = (calendarView: string, startDate: Date, endDate: Date) => {
    const dateRange = { start: +startDate };
    switch (calendarView) {
        case 'resourceTimelineDay':
            return { ...dateRange, end: +endOfDay(startDate) };
        case 'dayGridWeek':
            return { ...dateRange, end: +endOfWeek(startDate) };
        case 'dayGridMonth':
            return { ...dateRange, end: +endOfDay(endDate) };
        default:
            return { ...dateRange, end: +endDate };
    }
};
